import CRUDService from "../../services/base/CRUDService";

export default class IntegrationMessageService extends CRUDService {

  static ALL_URL = "integration/v1/integration-messages/";

  getBaseURL() {
    return IntegrationMessageService.ALL_URL;
  }

  process(id) {
    return this.getHttpRequest().put(`${IntegrationMessageService.ALL_URL}${id}/process`, {});
  }

}



// WEBPACK FOOTER //
// ./src/integration/messages/IntegrationMessageService.js